import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Cookies from 'js-cookie'; // Import js-cookie
import './App.css';
import Home from './Home';
import Category from './Category';
import Header from './components/Header';
import Privacy from './Privacy';
import Contact from './Contact'; // Import the Contact component
import { FaFacebook } from 'react-icons/fa'; // Import Facebook icon from react-icons

// Initialize GA4
ReactGA.initialize('G-BQTN3M4VHE');

// Create a component to track page views
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}

function App() {
  const [sliderValue, setSliderValue] = useState(() => {
    const savedValue = Cookies.get('sliderValue');
    return savedValue ? Number(savedValue) : 8; // Retrieve value from cookie or default to 8
  });

  useEffect(() => {
    Cookies.set('sliderValue', sliderValue.toString(), { expires: 7 }); // Save value to cookie
  }, [sliderValue]);

  return (
    <Router>
      <PageTracker />
      <Header sliderValue={sliderValue} setSliderValue={setSliderValue} />
      <Routes>
        <Route path="/" element={<Home sliderValue={sliderValue} />} />
        <Route path="/category/:categoryName" element={<Category sliderValue={sliderValue} />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} /> {/* Add this line */}
      </Routes>
      <footer className="site-footer">
        &copy; Dobré zprávy dnes ©2024 | <a href="/contact">Kontakt</a>
        <div className="footer-social">
          <a href="https://www.facebook.com/dobrezpravydnes/" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={24} />
          </a>
        </div>
      </footer>
    </Router>
  );
}

export default App;
